import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useProfile } from "@workspace/login";
import { logoutUser } from "../../store/actions";
// Redux
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "@workspace/common";
import { createSelector } from "reselect";

const Logout = (props) => {
  const dispatch = useDispatch();
  const [isCandidate, setIsCandidate] = useState(null);
  const { userProfile } = useProfile();

  useEffect(() => {
    const userGroup = userProfile?.user?.userGroup || [];
    const allowedGroups = ["Candidate Group"];
    const isCandidateUser = userGroup.some((group) =>
      allowedGroups.includes(group.groupName)
    );
    setIsCandidate(isCandidateUser);
  }, [userProfile]);

  const isUserLogoutSelector = createSelector(
    (state) => state.Login.isUserLogout,
    (isUserLogout) => isUserLogout
  );
  const isUserLogout = useSelector(isUserLogoutSelector);

  useEffect(() => {
    if (userProfile) {
      dispatch(logoutUser());
    }
  }, [dispatch, userProfile]);

  useEffect(() => {
    if (isUserLogout && isCandidate !== null) {
      if (isCandidate) {
        window.location.replace("/candidate/login");
      } else {
        window.location.replace("/login");
      }
    }
  }, [isUserLogout, isCandidate]);

  return <></>;
};

Logout.propTypes = {
  history: PropTypes.object,
};

export default withRouter(Logout);
